export default {
  BASE_URL: 'bid/audit/',
  api: [
    {
      name: 'list',
      method: 'GET',
      desc: '获取招标一级分类',
      path: 'bidHead/list',
      params: {
        category: '',
        keyword: '',
        undo: ''
      }
    },
    {
      name: 'bidHead',
      method: 'POST',
      desc: '审核是否通过',
      path: 'bidHead',
      params: {
        id: '',
        pass: false,
        reason: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/tender/audit.js